import { apiPathFunc } from "@api/util/apiPathFunc";
import type { IExtractParams } from "@/routes";

const pathBase = `/users/bulk/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const bulk = {
  post: apiPathFunc(pathBase),
};
